
import style from "./style.module.css"
const Footer = () => {
    return (
        <div className={style.mainDiv}>
            <p className={style.copyrightLine}>Made with <i className="fas fa-heart"></i> and <i className="fas fa-mug-hot"></i> by CS students Akshay & Praneet.</p>
            <p className={style.copyrightLine}>Copyright ©2022 B. N. N. College of Arts, Science & Commerce, Bhiwandi.</p>

        </div>
    )
}

export default Footer;